import { I18nProviderContext } from 'contexts/I18nProvider';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import { loggerInfo } from 'utils/infoLog';
import { getCsvResultDownload } from './services';

type ParamsProps = {
	id: string;
};

export const useDownloadXlsx = () => {
	const [isLoadingXlsx, setLoadingXlsx] = useState<boolean>(false);
	const [feedbackModal, setFeedbackModal] = useState({
		open: false,
		type: 'success',
		message: '',
	});

	const { translate } = useContext(I18nProviderContext);

	const handleCloseModalFeedback = () => {
		setFeedbackModal({ ...feedbackModal, open: false });
	};

	const onSuccessModal = () => {
		setFeedbackModal({
			type: 'success',
			open: true,
			message: translate('commons.xlsx.success'),
		});
	};

	const onErrorModal = () => {
		setFeedbackModal({
			type: 'error',
			open: true,
			message: translate('commons.xlsx.error'),
		});
	};

	const { id } = useParams() as ParamsProps;

	const fetchCsv = async () => {
		handleCloseModalFeedback();
		setLoadingXlsx(true);
		try {
			await getCsvResultDownload({ campaignId: id });

			onSuccessModal();
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'fetchCsvResults',
			});
			onErrorModal();
		} finally {
			setLoadingXlsx(false);
		}
	};

	return {
		isLoadingXlsx,
		handleDownloadCsv: fetchCsv,
		translate,
		feedbackModal,
		handleCloseModalFeedback,
		fetchCsv,
	};
};
